import * as React from 'react'
import { useDispatch } from 'redux-react-hook'
import { setPage } from '../../../actions/header.action'
import { Header } from '../..//molecules/header'
import styled from 'styled-components'
import { Size } from '../../../constants/app.constant'
import Contents from './contents'
import * as HeaderConst from '../../../constants/header.constant'
import useGetState from '../../../hooks/use-get-state'
import useFetchApi from '../../../hooks/use-fetch-api'
import { setDayReporLogDetails } from '../../../actions/report.action'
const { useEffect } = React
const ReportDetail = ({ match }) => {
  const dispatch = useDispatch()
  const {
    state: { auth },
  } = useGetState()
  const { isLoading, response } = useFetchApi({
    method: 'GET',
    url: `patients/${
      auth.user.idToken.payload['custom:userId']
    }/dayTrainingLogs/${encodeURI(match.params.reportId)}`,
  })
  useEffect(
    () => {
      document.title = '運動レポート詳細画面'
      dispatch(setPage(HeaderConst.HEADER_REPORT_DETAIL))
    },
    [dispatch]
  )
  useEffect(
    () => {
      if (response) dispatch(setDayReporLogDetails(response))
    },
    [dispatch, response]
  )
  return (
    !isLoading && (
      <Wrapper>
        <Header />
        <Contents />
      </Wrapper>
    )
  )
}
export default ReportDetail
const Wrapper = styled.div`
  max-width: ${Size.BREAK_POINT.MOBILE}px;
  background: white;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/components/pages/report_detail/report_detail.tsx